var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "w-100" },
    [
      _c(
        "v-tabs",
        {
          attrs: { "hide-slider": "" },
          model: {
            value: _vm.tab,
            callback: function ($$v) {
              _vm.tab = $$v
            },
            expression: "tab",
          },
        },
        _vm._l(_vm.tabs, function (text, i) {
          return _c("v-tab", { key: `barcode-setup-tab-${i}` }, [
            _vm._v(" " + _vm._s(text) + " "),
          ])
        }),
        1
      ),
      _c(
        "v-tabs-items",
        {
          staticClass: "barcode-setup",
          attrs: { touchless: "" },
          model: {
            value: _vm.tab,
            callback: function ($$v) {
              _vm.tab = $$v
            },
            expression: "tab",
          },
        },
        [
          _c("v-tab-item", { staticClass: "pa-5", attrs: { value: 0 } }, [
            _c("div", { staticClass: "primary--text mb-5" }, [
              _vm._v(" ข้อมูลในบาร์โค้ด "),
            ]),
            _c(
              "div",
              { staticClass: "d-flex align-center gap-3 mb-5" },
              [
                _c("div", { staticClass: "barcode-setup__label grey--text" }, [
                  _vm._v(" ตำแหน่งบน "),
                ]),
                _c("snt-select", {
                  attrs: {
                    value: _vm.pos1,
                    items: _vm.positions,
                    width: "165px",
                    "item-text": "text",
                    "item-value": "value",
                    "hide-details": "",
                  },
                  on: {
                    input: function ($event) {
                      return _vm.changePosition1($event)
                    },
                  },
                }),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "d-flex align-center gap-3 mb-5" },
              [
                _c("div", { staticClass: "barcode-setup__label grey--text" }, [
                  _vm._v(" ตำแหน่งกลาง "),
                ]),
                _c("snt-select", {
                  attrs: {
                    value: _vm.pos2,
                    items: _vm.midPositions,
                    "item-text": "text",
                    "item-value": "value",
                    width: "165px",
                    "hide-details": "",
                  },
                  on: {
                    input: function ($event) {
                      return _vm.changePosition2($event)
                    },
                  },
                }),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "d-flex align-center gap-3 mb-8" },
              [
                _c("div", { staticClass: "barcode-setup__label grey--text" }, [
                  _vm._v(" ตำแหน่งล่าง "),
                ]),
                _c("snt-select", {
                  attrs: {
                    value: _vm.pos3,
                    items: _vm.lastPositions,
                    width: "165px",
                    "item-text": "text",
                    "item-value": "value",
                    "hide-details": "",
                  },
                  on: {
                    input: function ($event) {
                      return _vm.$emit("update:pos3", $event)
                    },
                  },
                }),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "d-flex align-center gap-3 mb-5" },
              [
                _c("div", {}, [_vm._v(" แสดงตัวเลขบาร์โค้ด ")]),
                _c("v-spacer"),
                _c("v-switch", {
                  staticClass: "mt-0",
                  attrs: {
                    "input-value": _vm.showBarcodeNumber,
                    color: "primary",
                    "hide-details": "",
                    inset: "",
                  },
                  on: {
                    change: function ($event) {
                      return _vm.$emit("update:show-barcode-number", $event)
                    },
                  },
                }),
              ],
              1
            ),
          ]),
          _c("v-tab-item", { staticClass: "pa-5", attrs: { value: 1 } }, [
            _c("div", { staticClass: "primary--text mb-5" }, [
              _vm._v(" ตั้งค่ากระดาษ "),
            ]),
            _c(
              "div",
              { staticClass: "d-flex align-center gap-3 mb-5" },
              [
                _c("div", { staticClass: "barcode-setup__label grey--text" }, [
                  _vm._v(" ขนาดกระดาษ "),
                ]),
                _c("snt-select", {
                  attrs: {
                    value: _vm.pageSize,
                    items: _vm.paperSizes,
                    width: "165px",
                    placeholder: "กำหนดเอง",
                    "item-text": "text",
                    "item-value": "value",
                    "hide-details": "",
                  },
                  on: {
                    input: function ($event) {
                      return _vm.$emit("update:page-size", $event)
                    },
                  },
                }),
              ],
              1
            ),
            _c("div", { staticClass: "d-flex gap-3 mb-5" }, [
              _c(
                "div",
                { staticClass: "barcode-setup__label mt-2 grey--text" },
                [_vm._v(" กำหนดเอง ")]
              ),
              _c("div", [
                _c("div", { staticClass: "d-flex align-center gap-3 mb-5" }, [
                  _c(
                    "div",
                    { staticClass: "grey--text", style: { width: "55px" } },
                    [_vm._v(" กว้าง ")]
                  ),
                  _c(
                    "div",
                    { style: { width: "150px" } },
                    [
                      _c("snt-number-field", {
                        attrs: {
                          value: _vm.pageSize.width,
                          min: 25,
                          max: 1000,
                          "justify-controls": "end",
                          "hide-details": "",
                          rounded: "",
                          controls: "",
                          decimal: "",
                        },
                        on: {
                          change: function ($event) {
                            _vm.$emit("update:page-size", {
                              ..._vm.pageSize,
                              width: Number($event),
                            })
                          },
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "barcode-setup__label grey--text" },
                    [_vm._v(" mm ")]
                  ),
                ]),
                _c("div", { staticClass: "d-flex align-center gap-3" }, [
                  _c(
                    "div",
                    { staticClass: "grey--text", style: { width: "55px" } },
                    [_vm._v(" สูง ")]
                  ),
                  _c(
                    "div",
                    { style: { width: "150px" } },
                    [
                      _c("snt-number-field", {
                        attrs: {
                          value: _vm.pageSize.height,
                          min: 25,
                          max: 1000,
                          "justify-controls": "end",
                          "hide-details": "",
                          rounded: "",
                          controls: "",
                          decimal: "",
                        },
                        on: {
                          change: function ($event) {
                            _vm.$emit("update:page-size", {
                              ..._vm.pageSize,
                              height: Number($event),
                            })
                          },
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "barcode-setup__label grey--text" },
                    [_vm._v(" mm ")]
                  ),
                ]),
              ]),
            ]),
            _c("div", { staticClass: "d-flex align-center gap-3 mb-5" }, [
              _c("div", { staticClass: "barcode-setup__label grey--text" }, [
                _vm._v(" ขนาดฟอนต์ "),
              ]),
              _c(
                "div",
                { style: { width: "165px" } },
                [
                  _c("snt-number-field", {
                    attrs: {
                      value: _vm.fontSize,
                      min: 4,
                      max: 60,
                      "justify-controls": "end",
                      "hide-details": "",
                      rounded: "",
                      controls: "",
                      decimal: "",
                    },
                    on: {
                      change: function ($event) {
                        _vm.$emit("update:font-size", Number($event))
                      },
                    },
                  }),
                ],
                1
              ),
              _c("div", { staticClass: "barcode-setup__label grey--text" }, [
                _vm._v(" px "),
              ]),
            ]),
            _c("div", { staticClass: "mt-5 mb-5" }, [
              _vm._v(" จำนวนฉลากต่อหน้า "),
            ]),
            _c(
              "div",
              { staticClass: "d-flex align-center gap-3 mb-5" },
              [
                _c("div", { staticClass: "barcode-setup__label grey--text" }, [
                  _vm._v(" จำนวนคอลัมน์ "),
                ]),
                _c("snt-select", {
                  attrs: {
                    value: _vm.col,
                    items: [1, 2, 3, 4, 6],
                    width: "165px",
                    "hide-details": "",
                  },
                  on: {
                    input: function ($event) {
                      _vm.$emit("update:col", Number($event))
                    },
                  },
                }),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "d-flex align-center gap-3 mb-5" },
              [
                _c("div", { staticClass: "barcode-setup__label grey--text" }, [
                  _vm._v(" จำนวนแถว "),
                ]),
                _c("snt-select", {
                  attrs: {
                    value: _vm.row,
                    items: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
                    width: "165px",
                    "hide-details": "",
                  },
                  on: {
                    input: function ($event) {
                      _vm.$emit("update:row", Number($event))
                    },
                  },
                }),
              ],
              1
            ),
            _c("div", { staticClass: "mt-5 mb-5" }, [_vm._v(" จำนวนสำเนา ")]),
            _c("div", { staticClass: "d-flex align-center gap-3" }, [
              _c("div", { staticClass: "barcode-setup__label grey--text" }, [
                _vm._v(" สำเนา "),
              ]),
              _c(
                "div",
                { style: { width: "165px" } },
                [
                  _c("snt-number-field", {
                    attrs: {
                      value: _vm.copied,
                      min: 1,
                      "justify-controls": "end",
                      "hide-details": "",
                      rounded: "",
                      controls: "",
                    },
                    on: {
                      input: function ($event) {
                        _vm.$emit("update:copied", Number($event))
                      },
                    },
                  }),
                ],
                1
              ),
            ]),
          ]),
          _c("v-tab-item", { staticClass: "pa-5", attrs: { value: 2 } }, [
            _c("div", { staticClass: "primary--text mb-5" }, [
              _vm._v(" ตั้งค่าระยะขอบ "),
            ]),
            _c("div", { staticClass: "mt-5 mb-5" }, [
              _vm._v(" ระยะขอบกระดาษ "),
            ]),
            _c("div", { staticClass: "d-flex align-center gap-3 mb-5" }, [
              _c("div", { staticClass: "barcode-setup__label grey--text" }, [
                _vm._v(" ระยะขอบซ้าย "),
              ]),
              _c(
                "div",
                { style: { width: "100px" } },
                [
                  _c("snt-number-field", {
                    attrs: {
                      value: _vm.mx,
                      min: 0,
                      "justify-controls": "end",
                      "hide-details": "",
                      rounded: "",
                      controls: "",
                      decimal: "",
                    },
                    on: {
                      input: function ($event) {
                        _vm.$emit("update:mx", Number($event))
                      },
                    },
                  }),
                ],
                1
              ),
              _c("div", { staticClass: "barcode-setup__label grey--text" }, [
                _vm._v(" mm "),
              ]),
            ]),
            _c("div", { staticClass: "d-flex align-center gap-3 mb-5" }, [
              _c("div", { staticClass: "barcode-setup__label grey--text" }, [
                _vm._v(" ระยะขอบบน "),
              ]),
              _c(
                "div",
                { style: { width: "100px" } },
                [
                  _c("snt-number-field", {
                    attrs: {
                      value: _vm.my,
                      min: 0,
                      "justify-controls": "end",
                      "hide-details": "",
                      rounded: "",
                      controls: "",
                      decimal: "",
                    },
                    on: {
                      input: function ($event) {
                        _vm.$emit("update:my", Number($event))
                      },
                    },
                  }),
                ],
                1
              ),
              _c("div", { staticClass: "barcode-setup__label grey--text" }, [
                _vm._v(" mm "),
              ]),
            ]),
            _c("div", { staticClass: "mt-10 mb-5" }, [
              _vm._v(" ระยะห่างฉลาก "),
            ]),
            _c("div", { staticClass: "d-flex align-center gap-3 mb-5" }, [
              _c("div", { staticClass: "barcode-setup__label grey--text" }, [
                _vm._v(" ระยะขอบซ้าย "),
              ]),
              _c(
                "div",
                { style: { width: "100px" } },
                [
                  _c("snt-number-field", {
                    attrs: {
                      value: _vm.omx,
                      min: 0,
                      "justify-controls": "end",
                      "hide-details": "",
                      rounded: "",
                      controls: "",
                      decimal: "",
                    },
                    on: {
                      input: function ($event) {
                        _vm.$emit("update:omx", Number($event))
                      },
                    },
                  }),
                ],
                1
              ),
              _c("div", { staticClass: "barcode-setup__label grey--text" }, [
                _vm._v(" mm "),
              ]),
            ]),
            _c("div", { staticClass: "d-flex align-center gap-3 mb-5" }, [
              _c("div", { staticClass: "barcode-setup__label grey--text" }, [
                _vm._v(" ระยะขอบบน "),
              ]),
              _c(
                "div",
                { style: { width: "100px" } },
                [
                  _c("snt-number-field", {
                    attrs: {
                      value: _vm.omy,
                      min: 0,
                      "justify-controls": "end",
                      "hide-details": "",
                      rounded: "",
                      controls: "",
                      decimal: "",
                    },
                    on: {
                      input: function ($event) {
                        _vm.$emit("update:omy", Number($event))
                      },
                    },
                  }),
                ],
                1
              ),
              _c("div", { staticClass: "barcode-setup__label grey--text" }, [
                _vm._v(" mm "),
              ]),
            ]),
            _c("div", { staticClass: "mt-10 mb-5" }, [
              _vm._v(" ระยะห่างในฉลาก "),
            ]),
            _c("div", { staticClass: "d-flex align-center gap-3" }, [
              _c("div", { staticClass: "barcode-setup__label grey--text" }, [
                _vm._v(" ระหว่างตำแหน่ง "),
              ]),
              _c(
                "div",
                { style: { width: "100px" } },
                [
                  _c("snt-number-field", {
                    attrs: {
                      value: _vm.imy,
                      min: 0,
                      "justify-controls": "end",
                      "hide-details": "",
                      rounded: "",
                      controls: "",
                      decimal: "",
                    },
                    on: {
                      input: function ($event) {
                        _vm.$emit("update:imy", Number($event))
                      },
                    },
                  }),
                ],
                1
              ),
              _c("div", { staticClass: "barcode-setup__label grey--text" }, [
                _vm._v(" mm "),
              ]),
            ]),
          ]),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }